import React from 'react';
import { useSubtramiteForm } from '../../../hooks/useSubtramiteForm';
import { savePlanoRelevamiento } from '../../../services/tramiteService';
import { validaTiempo } from '../../../utils/validaciones';
import SubtramiteForm from '../../SubtramiteForm';
import { useAuthorization } from '@/auth/hooks/useAuthorization';
import { withRequiredTramite } from './withRequiredTramite';

const PlanoRelevamiento: React.FC = () => {
  const {
    data,
    loading,
    init,
    isUpdate,
    setIsUpdate,
    handleChange,
    handleSubmit,
    handleFinalizarSubtramite,
    handleReabrirSubtramite
  } = useSubtramiteForm({
    subtramiteKey: 'planorelevamiento',
    defaultData: {
      habilitado: true,
      fecini: new Date(),
      plano: null,
      plano_path: null,
    },
    saveFunction: savePlanoRelevamiento,
    successMessage: 'PlanoRelevamiento Guardado con éxito',
    errorTitle: 'Error al grabar PlanoRelevamiento',
  });

  const { canManageTramites, canUploadPlanosFiles } = useAuthorization();

  // Configuración de campos básicos
  const fields = [
    {
      type: 'toggle',
      name: 'habilitado',
      label: 'Habilitado:',
      inline: true,
      visible: canManageTramites && !isUpdate,
    },
    {
      type: 'date',
      name: 'fecini',
      label: 'Fecha de inicio:',
      inline: true,
      visible: canManageTramites && !isUpdate,
    },
  ];

  const canEditPlano = canManageTramites || (canUploadPlanosFiles && validaTiempo(data.plano_path, data.plano_udt));

  // Configuración de campos de archivos
  const fileFields = [
    {
      type: 'file',
      name: 'plano',
      label: 'Plano:',
      pathField: 'plano_path',
      visible: isUpdate,
      readOnly: !canEditPlano,
      helpText: 'Acción a realizar por la tramitadora o vendedor',
    },
  ];

  const btnGuardarVisible = fields.some(field => field.visible) ||
    fileFields.some(field => field.visible && !field.readOnly);


  return (
    <SubtramiteForm
      title="Plano de Relevamiento"
      data={data}
      loading={loading}
      init={init}
      isUpdate={isUpdate}
      setIsUpdate={setIsUpdate}

      handleChange={handleChange}
      handleSubmit={handleSubmit}
      handleFinalizarSubtramite={handleFinalizarSubtramite}
      handleReabrirSubtramite={handleReabrirSubtramite}
      btnGuardarVisible={btnGuardarVisible}
      fields={fields}
      fileFields={fileFields}
      subtramiteKey="planorelevamiento"
    />
  );
}

export default withRequiredTramite(PlanoRelevamiento);